const productHasOffer = (productGroups) =>
  productGroups
    .map((group) =>
      group.products
        .map((product) => product.informationKeys['pricing.offer.code'])
        .filter((offer) => offer && offer !== '')
        .some(Boolean)
    )
    .some(Boolean);

export const isCustomerEligibleForOffer = (hasActiveSubscription, isCustomerInactive) =>
  !hasActiveSubscription && !isCustomerInactive;

export const shouldShowOffer = (productGroups, hasActiveSubscription, isCustomerInactive) =>
  productHasOffer(productGroups) &&
  isCustomerEligibleForOffer(hasActiveSubscription, isCustomerInactive);
